import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "resistance-external__close" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { NModal } from 'naive-ui'
import { BfButton } from '@finetic/bikefitting-ui'
import { ResistanceModalText } from '@/types/resistance'


export default /*@__PURE__*/_defineComponent({
  __name: 'ResistanceExternal',
  props: {
    text: { default: ResistanceModalText.ENTER }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const emit = __emit



const showModal = computed({
  get() {
    return true
  },
  set() {
    close()
    return false
  },
})

const close = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NModal), {
    show: showModal.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    style: {"width":"600px"},
    class: "custom-card",
    preset: "card",
    title: _unref(t)('modules.resistance.external.modal.title'),
    bordered: false,
    size: "huge"
  }, {
    default: _withCtx(() => [
      (__props.text === _unref(ResistanceModalText).ENTER)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_unref(t)('modules.resistance.external.modal.enter')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_unref(t)('modules.resistance.external.modal.enterWarning')), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.text === _unref(ResistanceModalText).LEAVE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(t)('modules.resistance.external.modal.leave')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_unref(t)('modules.resistance.external.modal.leaveWarning')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(BfButton), { onClick: close }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.continue')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})